import { useState } from 'react';

const waveKeyframes = `
@keyframes aotv-hand-wave {
  0% { transform: rotate(0deg); }
  10% { transform: rotate(14deg); }
  20% { transform: rotate(-8deg); }
  30% { transform: rotate(14deg); }
  40% { transform: rotate(-4deg); }
  50% { transform: rotate(10deg); }
  60% { transform: rotate(0deg); }
  100% { transform: rotate(0deg); }
}`;

let injected = false;
function ensureCSS() {
  if (injected || typeof document === 'undefined') return;
  const style = document.createElement('style');
  style.textContent = waveKeyframes;
  document.head.appendChild(style);
  injected = true;
}

export function Hand({
  size = 28,
  onClick,
  title,
}: {
  size?: number;
  onClick?: () => void;
  title?: string;
}) {
  const [waving, setWaving] = useState(true);
  ensureCSS();
  const trigger = () => {
    setWaving(false);
    setTimeout(() => setWaving(true), 50);
    onClick?.();
  };
  return (
    <span
      onClick={trigger}
      title={title}
      style={{
        fontSize: size,
        display: 'inline-block',
        cursor: onClick ? 'pointer' : 'default',
        transformOrigin: '70% 70%',
        animation: waving ? 'aotv-hand-wave 2.5s ease 1' : undefined,
      }}
    >
      ✋
    </span>
  );
}
